import { put, takeEvery } from 'redux-saga/effects';
import { API } from '../../api/apiList';
import Axios from '../../config/AxiosConfig';
import * as type from '../actions/CMSData';

function* CMSData() {
    let apiDetails = API.find((API) => API.name === 'cms_setting');
    try {
        const response = yield Axios.get(apiDetails.FetchDataAPI).catch(Er => {
            throw (Er)
        })

        if (response && response.data) {
          yield put({ type: type.FETCH_CMSDATA_SUCCESS, payload: response.data.data });
        }
    }
    catch (er) {
        yield put({ type: type.FETCH_CMSDATA_ERROR, payload: er.toString() })
    }
}

export function* CMSDataSaga() {
    yield takeEvery(type.FETCH_CMSDATA_REQUEST, CMSData)
}